const MoneyBillIcon = ({ fill = "#ED3A56", height = 10, width = 10 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 19 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3908_1183)">
      <path
        d="M15.5 3.0947C15.5 4.18971 16.3969 5.07999 17.5 5.07999V3.0947H15.5ZM14.5 3.0947H4.5C4.5 4.73877 3.15625 6.07264 1.5 6.07264V10.0432C3.15625 10.0432 4.5 11.3771 4.5 13.0212H14.5C14.5 11.3771 15.8438 10.0432 17.5 10.0432V6.07264C15.8438 6.07264 14.5 4.73877 14.5 3.0947ZM1.5 13.0212H3.5C3.5 11.9262 2.60313 11.0359 1.5 11.0359V13.0212ZM17.5 11.0359C16.3969 11.0359 15.5 11.9262 15.5 13.0212H17.5V11.0359ZM1.5 3.0947V5.07999C2.60313 5.07999 3.5 4.18971 3.5 3.0947H1.5ZM0.5 2.10205H1.5H17.5H18.5V3.0947V13.0212V14.0138H17.5H1.5H0.5V13.0212V3.0947V2.10205ZM11.5 8.05793C11.5 7.5314 11.2893 7.02643 10.9142 6.65412C10.5391 6.2818 10.0304 6.07264 9.5 6.07264C8.96957 6.07264 8.46086 6.2818 8.08579 6.65412C7.71071 7.02643 7.5 7.5314 7.5 8.05793C7.5 8.58447 7.71071 9.08943 8.08579 9.46175C8.46086 9.83406 8.96957 10.0432 9.5 10.0432C10.0304 10.0432 10.5391 9.83406 10.9142 9.46175C11.2893 9.08943 11.5 8.58447 11.5 8.05793ZM6.5 8.05793C6.5 7.26813 6.81607 6.51068 7.37868 5.95221C7.94129 5.39374 8.70435 5.07999 9.5 5.07999C10.2956 5.07999 11.0587 5.39374 11.6213 5.95221C12.1839 6.51068 12.5 7.26813 12.5 8.05793C12.5 8.84773 12.1839 9.60518 11.6213 10.1637C11.0587 10.7221 10.2956 11.0359 9.5 11.0359C8.70435 11.0359 7.94129 10.7221 7.37868 10.1637C6.81607 9.60518 6.5 8.84773 6.5 8.05793Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_3908_1183">
        <rect width="18" height="15.8824" fill="white" transform="translate(0.5 0.117676)" />
      </clipPath>
    </defs>
  </svg>
);
export default MoneyBillIcon;
